import React from 'react';
import PropTypes from 'prop-types';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';

export const EmptyFilterView = ({ i18n, imagePath }) => {
  const bulbIconSrc = `${imagePath}Recommendation/no-opportunity-icon.png`;

  return (
    <div className="empty-filter-view">
      <div className="empty-icon">
        <img src={bulbIconSrc} alt={i18n.getString('Details_View_Filter_Empty_Title')} />
      </div>
      <div className="empty-details">
        <h1 className="empty-title type-bold">{i18n.getString('Details_View_Filter_Empty_Title')}</h1>
        <h2 className="empty-sub-title">
          <LearnMoreLink
            text={i18n.getString('Details_View_Filter_Empty_Details')}
            topic="ext60029"
            linkText={i18n.getString('Learn_more_link_text')}
          />
        </h2>
      </div>
    </div>);
};

EmptyFilterView.propTypes = {
  i18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  imagePath: PropTypes.string.isRequired,
};
